import { render, staticRenderFns } from "./approval-prescription-charts.vue?vue&type=template&id=56a05cd7&scoped=true&lang=pug&"
import script from "./approval-prescription-charts.vue?vue&type=script&lang=ts&"
export * from "./approval-prescription-charts.vue?vue&type=script&lang=ts&"
import style0 from "./approval-prescription-charts.vue?vue&type=style&index=0&id=56a05cd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a05cd7",
  null
  
)

export default component.exports